import { communityImage } from "@/mocks/comics";

const quotes = [
  { name: "阿澄", text: "收藏后每天打开都能看到有没有新章，再也不用到处翻评论问进度了。" },
  { name: "半糖", text: "连载进度一目了然，最新的几部连载都是我每天必刷的。" },
  { name: "南风", text: "追更体验很顺畅，最新话更新提醒特别及时，强推！" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-team-line"></i> 关于妖精漫画
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
              为追更的你，打造顺畅入口
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              妖精漫画是一个专注漫画连载与追更体验的入口，我们把最新话、更新状态和连载进度
              集中整理，让你不用再到处翻评论问进度。收藏想追的作品后，每次打开都能第一时间
              看到有没有新章节，追更从此变得简单顺畅。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们坚持真实、及时、易用三个原则：更新状态真实同步、最新话及时呈现、
              进度查看直观清晰，让每一个追更的人都省心。
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              {[
                { icon: "ri-check-double-line", label: "进度一目了然" },
                { icon: "ri-notification-3-line", label: "更新及时提醒" },
                { icon: "ri-device-line", label: "多端顺畅追更" },
              ].map((b) => (
                <span
                  key={b.label}
                  className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-2 text-sm text-secondary-900"
                >
                  <i className={`${b.icon} text-primary-600`}></i>
                  {b.label}
                </span>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-background-200">
            <img
              src={communityImage}
              alt="妖精漫画追更社区，朋友围坐一起阅读漫画的温馨插画"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
          {quotes.map((q) => (
            <figure
              key={q.name}
              className="rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                {q.text}
              </blockquote>
              <figcaption className="mt-4 text-sm font-semibold text-foreground-950">
                {q.name}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}